<template>
  <!-- 保持原有模板结构不变 -->
  <div class="banner">
    <div class="titleBox" v-show="showTitle">
      <img src="../assets/img/index/titleImg.png" alt="" class="indexTitle" />
      <img :src="startBtnImg" alt="" @click="intoPageFuntion" class="intoButton" @mouseenter="startBtnChageInto" @mouseleave="outBtnChangeOut" />
      <img src="../assets/img/index/机器人.gif" alt="" class="robotGif" />
      <img src="../assets/img/index/电脑.gif" alt="" class="jsjGif" />
    </div>
    <img src="../assets/img/double/title.png" alt="" class="title" />
    <img src="../assets/img/double/itemLIst.png" alt="" class="itemList" />
    <img src="../assets/img/index/list.png" alt="" class="list" v-show="setups < 3" />
    <img src="../assets/img/index/机器人.gif" alt="" class="robot" />
    <div class="messageBox" v-show="!showTitle">
      {{ tips }}
      <img :src="nextSrc" alt="" class="nextBtn" @click="nextSetup" @mouseenter="nextBtnActive" @mouseleave="nextBtnBtn" v-show="setups < 2" />
    </div>
    <img :src="nextSetupSrc" alt="" @click="showList" @mouseenter="nextSetupBtnActive" @mouseleave="nextSetupBtnBtn" v-show="setups === 2" class="nextSetupImg" />
    <img :src="nextSetupSrc" alt="" v-show="setups === 3" @click="upPage" class="nextButton" @mouseenter="nextSetupBtnActive" @mouseleave="nextSetupBtnBtn" />
    <img :src="homeBtnImg" alt="" class="homeBtn" @mouseenter="homeBtnActive" @mouseleave="homeBtn" @click="bankHome" />
    <audio ref="audioPlay" :loop="false">
      <source :src="audioSrc" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlay02" :loop="false">
      <source :src="fourAudio" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import anime from "animejs";
// 保持原始导入不变
import startBtn from "../assets/img/index/buttonImg.png";
import startBtnActive from "../assets/img/index/buttonImgActive.png";
import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";
import oneAudio from "../assets/audio/home/oneAudio.mp3";
import twoAudio from "../assets/audio/home/twoAudio.mp3";
import threeAudio from "../assets/audio/home/threeAudio.mp3";
import fourAudio from "../assets/audio/home/fourAudio.mp3";
import nextImg from "../assets/img/index/nextImg.png";
import nextImgActive from "../assets/img/index/nextImgActive.png";
import nextSetupImg from "../assets/img/reason/submitBtn.png";
import nextSetupActiveImg from "../assets/img/reason/submitBtnActive.png";

const router = useRouter();
const audioPlay = ref<HTMLAudioElement>();
const showTitle = ref(true);
const setups = ref(0);
const tips = ref("你了解佩戴口罩的作用嗎？讓我們一起進行測試。");
const startBtnImg = ref(startBtn);
const homeBtnImg = ref(home);
const audioSrc = ref(oneAudio);
const nextSrc = ref(nextImg);
const nextSetupSrc = ref(nextSetupImg);
const audioPlay02 = ref();
const messageArray = ["你了解佩戴口罩的作用嗎？讓我們一起進行測試。", "我地先準備白紙兩張、卡紙兩張、魚尾夾四個、口罩、顏色溶液、噴水瓶、尺子。", "準備好所有用具，我們就可以開始測試喇。"];
// 新增状态控制
let isManualStop = false;
// 安全播放方法
const safePlay = async (src: string) => {
  try {
    if (!audioPlay.value) return;
    audioPlay02.value.pause();
    // 重置状态
    isManualStop = false;
    audioPlay.value.pause();
    audioPlay.value.currentTime = 0;
    audioPlay.value.src = src;

    // 单次监听加载完成
    await new Promise<void>((resolve, reject) => {
      const successHandler = () => resolve();
      const errorHandler = (e: Event) => reject(e);

      audioPlay.value!.addEventListener("canplaythrough", successHandler, { once: true });
      audioPlay.value!.addEventListener("error", errorHandler, { once: true });
    });

    // 单次监听播放结束
    audioPlay.value.addEventListener("ended", handleAudioEnd, { once: true });

    // 开始播放
    audioPlay.value.volume = 0.5;
    await audioPlay.value.play();
  } catch (error) {
    console.error("播放失败:", error);
    tips.value = "音频加载失败，请刷新重试";
  }
};

// 处理音频结束
const handleAudioEnd = () => {
  if (isManualStop) return;
  if (setups.value < 2) {
    setups.value++;
    audioSrc.value = [oneAudio, twoAudio, threeAudio][setups.value];
    safePlay(audioSrc.value);
    tips.value = messageArray[setups.value];
  }
};

// 进入页面流程
const intoPageFuntion = () => {
  anime({
    targets: ".intoButton",
    translateY: [0, -1200],
    scale: [1, 0],
    duration: 800,
    easing: "linear",
  });
  anime({
    targets: ".indexTitle",
    translateY: [0, -600],
    scale: [1, 0],
    duration: 800,
    easing: "linear",
  });
  showTitle.value = false;
  setups.value = 0;
  safePlay(oneAudio);
};

// 其他原有方法保持不变
const upPage = () => {
  if (setups.value === 3) {
    router.push({ name: "forecast" });
  }
};
const startBtnChageInto = () => {
  startBtnImg.value = startBtnActive;
};
const outBtnChangeOut = () => {
  startBtnImg.value = startBtn;
};
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};
const nextBtnActive = () => {
  nextSrc.value = nextImgActive;
};
const nextBtnBtn = () => {
  nextSrc.value = nextImg;
};
const nextSetupBtnActive = () => {
  nextSetupSrc.value = nextSetupActiveImg;
};
const nextSetupBtnBtn = () => {
  nextSetupSrc.value = nextSetupImg;
};
const nextSetup = () => {
  handleAudioEnd();
};
const showList = () => {
  if (setups.value === 2) {
    audioPlay.value.pause();
    setups.value = 3;
    anime({
      targets: ".itemList",
      scale: [0, 1],
      duration: 800,
      easing: "linear",
    });
    anime({
      targets: ".robot",
      opacity: [1, 0],
      duration: 400,
      easing: "linear",
    });
    anime({
      targets: ".messageBox",
      opacity: [1, 0],
      duration: 400,
      easing: "linear",
    });
    anime({
      targets: ".nextButton",
      opacity: [0, 1],
      duration: 400,
      easing: "linear",
    });
  }
};
const bankHome = () => {
  location.reload();
};
// 清理监听
onUnmounted(() => {
  if (audioPlay.value) {
    audioPlay.value.pause();
    audioPlay.value.src = "";
  }
});
onMounted(async () => {
  await audioPlay02.value.play();
});
</script>

<!-- 保持原有样式不变 -->
<style scoped lang="scss">
@font-face {
  font-family: "tips";
  src: url("../assets/fonts/SourceHanSansCN-Regular.otf");
}
.banner {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  overflow: hidden;
  background-image: url(../assets/img/double/background.png);
  background-size: 100% 100%;
  position: relative;
  .titleBox {
    width: 100vw;
    height: 100vh;
    position: absolute;
    text-align: center;
    background-size: 100% 100%;
    background-image: url(../assets/img/index/oneIndexBackground.png);
    z-index: 9;
    .indexTitle {
      cursor: default;
      position: absolute;
      top: 33vh;
      left: 14vw;
      width: 61vw;
    }
    .intoButton {
      cursor: pointer;
      position: absolute;
      bottom: 27vh;
      left: 42vw;
      width: 17vw;
    }
    .robotGif {
      position: absolute;
      top: 48vh;
      left: 0vw;
      width: 25vw;
    }
    .jsjGif {
      position: absolute;
      top: 54vh;
      left: 73vw;
      width: 25vw;
    }
  }
  .list {
    position: absolute;
    right: 10vw;
    top: 32vh;
    width: 39vw;
  }
  .itemList {
    position: absolute;
    top: 22vh;
    left: 9vw;
    width: 84vw;
    transform: scale(0);
  }
  // 机器人位置
  .robot {
    position: absolute;
    top: 48vh;
    left: 0vw;
    width: 25vw;
  }
  .messageBox {
    position: absolute;
    left: 13vw;
    top: 32vh;
    width: 30vw;
    font-size: 1.5vw;
    line-height: 6vh;
    letter-spacing: 1px;
    color: rgba(4, 70, 147);
    background-size: 100% 100%;
    padding: 4vh 3vw 12vh;
    box-sizing: border-box;
    background-image: url(../assets/img/double/tipBackg.png);
  }
  .nextBtn {
    position: absolute;
    bottom: 3vh;
    left: 20vw;
    width: 6vw;
  }
  .nextButton {
    position: absolute;
    bottom: 5%;
    right: 44%;
    width: 12vw;
    text-align: center;
    opacity: 0;
  }
  .nextSetupImg {
    position: absolute;
    bottom: 2vh;
    left: 42vw;
    width: 16vw;
  }
  .homeBtn {
    position: absolute;
    bottom: 2vh;
    right: 1.5vh;
    width: 5vw;
  }
  .title {
    position: absolute;
    top: 13vh;
    left: 25vw;
    width: 52vw;
  }
}
</style>
